<template>
<div class="popupWrap">
  <div class="popup_inner">
    <span><a href="javascript:" @click="colseModal()" ><img src="/static/images/main/close_menu.png" alt=""></a></span>
    <h2>모바일 템플릿앱 다운로드 상세보기</h2>

    <!-- 내용 -->
    <div class="pop_sdk">
      <table>
        <colgroup>
          <col width="20%">
          <col width="*">
        </colgroup>
        <tbody>
          <tr>
            <th>유형</th>
            <td v-text="categoryNm(item.category)"></td>
          </tr>
          <tr>
            <th>제목</th>
            <td v-text="item.title"></td>
          </tr>
          <tr>
            <th>내용</th>
            <td v-text="item.contents" class="textprewrap"></td>
          </tr>
          <tr>
            <th>Ver</th>
            <td v-text="item.version"></td>
          </tr>
          <tr>
            <th>첨부파일</th>
            <td>
              <ul>
                <li v-for="fileItem in item.files" v-bind:key="fileItem.keyid" >
                <a :href="'/web/file/download/'+fileItem.keyid">
                <img src="/static/images/contents/icon_file.png" :alt="fileItem.orgFileName" :text="fileItem.orgFileName" :title="fileItem.orgFileName"  />
                {{ fileItem.orgFileName }}
                </a>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn_area taC">
      <a href="javascript:" @click="colseModal()" class="btn_blue">확인</a>
    </div>

  </div>
</div>
</template>
<script>

export default {
  data: function () {
    return {
      item: this.viewmtp
    }
  },
  props: [
    'viewmtp'
  ],
  methods: {
    colseModal () {
      this.$emit('close')
    },
    categoryNm (id) {
      if (id === 'GUIDE') {
        return '가이드문서'
      } else if (id === 'APIDOC') {
        return '연동규격서'
      } else if (id === 'SOURCE') {
        return '소스'
      } else {
        return id
      }
    }
  },
  created () {

  },
  computed: {
  }
}
</script>

<style scoped>
th, td {
  text-align: center;
}
.textprewrap {
    white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MTemplateView.vue